import React, { useContext, useEffect, useState } from 'react';
import { Input, Icon, theme, Space } from 'components';
import { useDebounce } from 'hooks';
import styled from 'styled-components';
import AnsweringSearchContext from './AnsweringSearchContext';
import { TabMenu } from './types';

const SearchBar = () => {
  const { selectedTab, text, setText } = useContext(AnsweringSearchContext);
  const [localText, setLocalText] = useState(text);
  const debouncedText = useDebounce(localText, 500);

  useEffect(() => {
    setText(debouncedText);
  }, [debouncedText]);

  useEffect(() => {
    setLocalText('');
  }, [selectedTab]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalText(e.target.value);
  };
  return (
    <StyledInput
      allowClear
      placeholder={`Search ${
        selectedTab === TabMenu.Brokerages ? 'brokerages' : 'agents'
      }`}
      prefix={<Icon type="search" color="gray7" />}
      value={localText}
      onChange={onChangeHandler}
      data-cy="answering-search"
    />
  );
};

const StyledInput = styled(Input)`
  width: 355px;
  height: 50px;
  display: flex;
  align-items: flex-end;
  & > span {
    height: 40px;
  }
`;

export default SearchBar;
